import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-product-fill 302",
  "use": "icon-product-fill 302-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-product-fill 302\"><path d=\"M853.333333 384v405.333333a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V384h682.666666z m-384 64h-170.666666v64h170.666666v-64zM733.482667 170.666667a64 64 0 0 1 57.237333 35.370666l55.850667 111.68 1.024 2.282667H178.816l54.698667-113.173333A64 64 0 0 1 291.136 170.666667h442.346667z\" p-id=\"21119\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol